



























































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import CbxTitle from "@/views/lookups/CbxTitle.vue";
import CbxGender from "@/views/lookups/CbxGender.vue";
import CbxMaritalStatus from "@/views/lookups/CbxMaritalStatus.vue";
import CbxTaxBasisAssessment from "@/views/lookups/CbxTaxBasisAssessment.vue";
import CbxYesNoDefault from "@/views/lookups/CbxYesNoDefault.vue";
import CbxHealthStatus from "@/views/lookups/CbxHealthStatus.vue";
import CbxCountry from "@/views/lookups/CbxCountry.vue";
import CbxCounty from "@/views/lookups/CbxCounty.vue";
import CbxEmploymentStatus from "@/views/lookups/CbxEmploymentStatus.vue";
import CbxOccupation from "@/views/lookups/CbxOccupation.vue";
import {
  FactFindDetailsDto,
  UpdateDetailsCommand,
  CountyDto,
  OccupationDto,
  CountryDto,
  TitleDto,
  GenderDto,
  MaritalStatusDto,
  TaxBasisAssessmentDto,
  YesNoDefaultDto,
  HealthStatusDto,
  EmploymentStatusDto
} from "@/api/ClientPortalApiClient";

import ApiFactory from "../../api/ApiFactory";
import AlertService from "../../services/alert.service";
import { LoadingSpinnerService } from "@/store";
import { FormatDate } from "@/filters/FormatDate";

@Component({
  components: {
    CbxTitle,
    CbxGender,
    CbxMaritalStatus,
    CbxTaxBasisAssessment,
    CbxYesNoDefault,
    CbxHealthStatus,
    CbxCountry,
    CbxCounty,
    CbxEmploymentStatus,
    CbxOccupation
  }
})
export default class FactFindDetails extends Vue {
  private alertService = new AlertService();
  private contactId: number = 0;
  private displayModel = new FactFindDetailsDto();
  private emptyDetails = new FactFindDetailsDto();
  private mode = "edit";
  private modelSig = "";

  $refs!: {
    titles: CbxTitle;
    genders: CbxGender;
    maritalStatus: CbxMaritalStatus;
    taxBasisAssessments: CbxTaxBasisAssessment;
    smokerStatus: CbxYesNoDefault;
    healthStatus: CbxHealthStatus;
    domiciles: CbxCountry;
    counties: CbxCounty;
    countries: CbxCountry;
    employmentStatus: CbxEmploymentStatus;
    occupations: CbxOccupation;
    mainForm: HTMLFormElement;
  };

  public created() {
    this.contactId = parseInt(this.$route.params.contactId);
    this.fetchDetails(true);
  }

  private saveDetails(e: Event) {
    e.preventDefault();
    this.save();
  }

  private async save(): Promise<boolean> {
    if (!this.$refs.mainForm.checkValidity()) {
      this.alertService.error(
        "Form Validation Failed",
        "Please complete all required fields"
      );
      return false;
    }

    LoadingSpinnerService.Show("Saving personal details...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdateDetailsCommand();

    cmd.id = this.displayModel.id;
    cmd.firstName = this.displayModel.firstName;
    cmd.lastName = this.displayModel.lastName;
    cmd.email = this.displayModel.email;
    cmd.phoneNo = this.displayModel.phoneNo;
    cmd.mobileNo = this.displayModel.mobileNo;
    cmd.workNo = this.displayModel.workNo;
    cmd.addressLine_1 = this.displayModel.addressLine_1;
    cmd.addressLine_2 = this.displayModel.addressLine_2;
    cmd.addressLine_3 = this.displayModel.addressLine_3;
    cmd.addressLine_4 = this.displayModel.addressLine_4;
    cmd.dateOfBirth = FormatDate.forApi(this.displayModel.dateOfBirth);

    if (this.displayModel.title) {
      cmd.titleId = this.displayModel.title.id;
    }
    if (this.displayModel.gender) {
      cmd.genderId = this.displayModel.gender.id;
    }
    if (this.displayModel.maritalStatus) {
      cmd.maritalStatusId = this.displayModel.maritalStatus.id;
    }
    if (this.displayModel.smokerStatus) {
      cmd.smokerStatusId = this.displayModel.smokerStatus.id;
    }
    if (this.displayModel.addressCounty) {
      cmd.addressCountyId = this.displayModel.addressCounty.id;
    }
    if (this.displayModel.addressCountry) {
      cmd.addressCountryId = this.displayModel.addressCountry.id;
    }
    if (this.displayModel.employmentStatus) {
      cmd.employmentStatusId = this.displayModel.employmentStatus.id;
    }

    try {
      var result = await api.factFindDetails_IndexPUT(cmd);
      if (result) {
        this.modelSig = JSON.stringify(this.displayModel.toJSON());
        LoadingSpinnerService.Success("Personal details saved successfully.");
        return true;
      } else {
        LoadingSpinnerService.Failure(
          "Personal details could not be saved. Please try again."
        );
      }
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Personal details could not be saved. Please try again."
      );
    }

    return false;
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.save();
        }
      }
    }

    return true;
  }

  private isDisplayModelEmpty(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    const s2 = JSON.stringify(this.emptyDetails.toJSON()).toString();

    if (s1 !== s2) return false;
    return true;
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private async fetchDetails(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading personal details...");
    const api = ApiFactory.CreateDataClient();
    await api
      .factFindDetails_IndexGET(this.contactId)
      .then(result => {
        if (result) {
          this.loadDetails(result);
          if (showLoader) LoadingSpinnerService.Hide();
        } else {
          LoadingSpinnerService.Failure(
            "Could not load personal details. Please try again."
          );
        }
      })
      .catch(error => {
        LoadingSpinnerService.Failure(
          "Could not load personal details. Please try again."
        );
      });
  }

  private loadDetails(details: FactFindDetailsDto) {
    this.displayModel = details;
    this.displayModel.dateOfBirth = FormatDate.forInput(details.dateOfBirth);
    this.modelSig = JSON.stringify(this.displayModel.toJSON());
    if (details.title) {
      this.$refs.titles.setSelected(details.title);
    }
    if (details.gender) {
      this.$refs.genders.setSelected(details.gender);
    }
    if (details.maritalStatus) {
      this.$refs.maritalStatus.setSelected(details.maritalStatus);
    }
    if (details.smokerStatus) {
      this.$refs.smokerStatus.setSelected(details.smokerStatus);
    }
    if (details.addressCounty) {
      this.$refs.counties.setSelected(details.addressCounty);
    }
    if (details.addressCountry) {
      this.$refs.countries.setSelected(details.addressCountry);
    }
    if (details.employmentStatus) {
      this.$refs.employmentStatus.setSelected(details.employmentStatus);
    }
  }

  private countrySelected(country: CountryDto) {
    this.displayModel.addressCountry = country;
  }
  private countySelected(county: CountyDto) {
    this.displayModel.addressCounty = county;
  }
  private titleSelected(title: TitleDto) {
    this.displayModel.title = title;
  }
  private genderSelected(gender: GenderDto) {
    this.displayModel.gender = gender;
  }
  private maritalStatusSelected(maritalStatus: MaritalStatusDto) {
    this.displayModel.maritalStatus = maritalStatus;
  }

  private smokerStatusSelected(smokerStatus: YesNoDefaultDto) {
    this.displayModel.smokerStatus = smokerStatus;
  }

  private employmentStatusSelectd(employmentStatus: EmploymentStatusDto) {
    this.displayModel.employmentStatus = employmentStatus;
  }
}
